/// <amd-module name="VSSUI/Components/Card/Card" />
import * as React from "react";
import { Button } from "VSSUI/Button";
import { Header } from "VSSUI/Header";
import { IconSize } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";
import * as Resources from "VSSUI/Resources.Card";
import { css } from "VSSUI/Util";
import { ICardProps } from "./Card.Props";
import { CardContent } from "./CardContent";
import { CustomCard } from "./CustomCard";

export const Card: React.SFC<ICardProps> = props => {
    const { collapsible, collapsed = false, titleProps = {}, headerCommandBarItems, onCollapseClick, renderHeader } = props;
    const { text } = titleProps;
    return (
        <CustomCard className={css(props.className, (text || headerCommandBarItems) && "bolt-card-with-header")}>
            {collapsible ? (
                <Observer collapsed={collapsed}>
                    {(observerProps: { collapsed: boolean }) => (
                        <>
                            {(text || headerCommandBarItems || renderHeader) && (
                                <div className="flex-row">
                                    <Button
                                        ariaExpanded={!observerProps.collapsed}
                                        ariaLabel={
                                            (text ? text + " " : "") + (observerProps.collapsed ? Resources.ExpandButtonAriaLabel : Resources.CollapseButtonAriaLabel)
                                        }
                                        subtle={true}
                                        iconProps={{ iconName: observerProps.collapsed ? "ChevronRightMed" : "ChevronDownMed", size: IconSize.small }}
                                        className="bolt-card-expand-button flex-self-start"
                                        onClick={onCollapseClick}
                                    />
                                    {renderHeader ? (
                                        renderHeader()
                                    ) : (
                                        <CardHeader
                                            {...props}
                                            headerClassName={css(
                                                props.headerClassName,
                                                "bolt-card-expandable-header",
                                                observerProps.collapsed && "bolt-card-header-collapsed"
                                            )}
                                        />
                                    )}
                                </div>
                            )}
                            {!observerProps.collapsed && <CardContent {...props.contentProps}>{props.children}</CardContent>}
                        </>
                    )}
                </Observer>
            ) : (
                <>
                    {renderHeader ? renderHeader() : (text || headerCommandBarItems) && <CardHeader {...props} />}
                    <CardContent {...props.contentProps}>{props.children}</CardContent>
                </>
            )}
        </CustomCard>
    );
};

const CardHeader: React.SFC<ICardProps> = props => {
    const {
        collapsible,
        titleProps = {},
        headerBreakpoints,
        headerClassName,
        headerCommandBarItems,
        headerDescriptionProps = {},
        headerIconProps
    } = props;
    const { text, className, id, size, ariaLevel } = titleProps;
    return (
        <Header
            className={css(headerClassName, "bolt-card-header", collapsible && "bolt-card-header-collapsible")}
            commandBarClassName="justify-end"
            commandBarItems={headerCommandBarItems}
            description={headerDescriptionProps.text}
            descriptionClassName={headerDescriptionProps.className}
            headerBreakpoints={headerBreakpoints}
            titleId={id}
            titleIconProps={headerIconProps}
            title={text}
            titleAriaLevel={ariaLevel}
            titleClassName={className}
            titleSize={size}
        />
    );
};
